import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SCardHeaderComponent } from './card-header/card-header.component';

@Component({
  selector: 's-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [SCardHeaderComponent],
})
export class SCardComponent implements OnInit {
  constructor() {}

  @Input() title?: string | undefined;
  @Input() hoverable?: boolean | undefined = false;
  @Input() padding?: boolean | undefined = true;
  @Input() html?: string | undefined = '';
  @Input() maxWidth?: string | undefined = '';

  @Output() click = new EventEmitter<void>();

  get rootClasses(): string {
    return [this.hoverable ? 'card--hoverable' : '', this.padding ? 'card--padding' : ''].join(' ');
  }

  get rootStyles(): string {
    return [this.maxWidth ? `max-width: ${this.maxWidth};` : ''].join('');
  }

  handleClick(): void {
    this.click.emit();
  }

  ngOnInit(): void {}
}
